import React from 'react';
import { Button } from '@mui/material';

type CtaType = 'next' | 'create' | 'password';
export const ctaLabelMap: { [k in CtaType]: string } = {
  next: 'Next',
  create: 'Create account',
  password: 'Create password',
};
interface NextButtonProps {
  onClick(): void;
  ctaType: CtaType;
}

const NextButton: React.FC<NextButtonProps> = ({ onClick, ctaType }: NextButtonProps) => {
  return (
    <Button
      sx={{
        width: { xs: '90%', sm: '327px' },
        mt: 2,
        mb: { xs: 4.5, sm: 4 },
        zIndex: 2,
      }}
      size="large"
      variant="contained"
      color="primary"
      onClick={onClick}>
      {ctaLabelMap[ctaType]}
    </Button>
  );
};

export default NextButton;
